import app from './app'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
const cn = {
	app,
	...zhLocale
}
export default cn;